<svg id="Group_2_Copy_11" data-name="Group 2 Copy 11" xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30">
  <rect id="Rectangle" width="32" height="26" rx="1.6" fill="#c7cfff"/>
  <g id="Group_38" data-name="Group 38" transform="translate(3.4 5.7)">
    <rect id="Rectangle-2" data-name="Rectangle" width="25.2" height="3" rx="0.4" fill="#4562ff"/>
    <rect id="Rectangle_Copy_12" data-name="Rectangle Copy 12" width="25.2" height="3" rx="0.4" transform="translate(0 5.6)" fill="#4562ff"/>
    <rect id="Rectangle_Copy_13" data-name="Rectangle Copy 13" width="25.2" height="3" rx="0.4" transform="translate(0 11.6)" fill="#4562ff"/>
  </g>
  <path id="Polygon_1" data-name="Polygon 1" d="M4.293.707a1,1,0,0,1,1.414,0L8.293,3.293A1,1,0,0,1,7.586,5H2.414a1,1,0,0,1-.707-1.707Z" transform="translate(5 20) rotate(90)" fill="#c7cfff"/>
</svg>
